var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "1280.000000pt",
    viewBox: "0 0 1280.000000 1280.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1280.000000) scale(0.100000,-0.100000)",
    fill: "#bfd730",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6035 12789 c-2168 -128 -4111 -1331 -5189 -3212 -443 -772 -715 -1618 -810 -2517 -141 -1322 146 -2678 810 -3837 867 -1513 2307 -2605 3992 -3028 1608 -404 3303 -171 4739 651 1604 917 2734 2486 3098 4299 303 1511 46 3094 -721 4432 -971 1696 -2665 2858 -4589 3148 -444 67 -908 89 -1330 64z m885 -544 c593 -56 1138 -188 1683 -406 193 -78 571 -263 752 -369 869 -510 1564 -1200 2095 -2080 185 -305 410 -806 533 -1185 477 -1463 353 -3061 -343 -4440 -318 -629 -667 -1102 -1191 -1611 -583 -566 -1361 -1038 -2160 -1309 -446 -151 -876 -243 -1374 -291 -250 -25 -780 -25 -1030 0 -498 48 -928 140 -1374 291 -476 162 -996 420 -1396 692 -636 434 -1178 979 -1595 1603 -288 431 -543 959 -704 1457 -475 1471 -352 3058 344 4438 69 138 161 309 205 380 594 982 1424 1745 2440 2245 738 363 1478 555 2325 604 138 8 633 -4 790 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6150 9266 l0 -2113 -52 -22 c-318 -132 -517 -455 -494 -801 l6 -95 -1092 -631 c-765 -441 -1093 -635 -1092 -647 1 -11 220 -400 239 -425 1 -1 496 283 1100 632 l1098 634 51 -40 c67 -52 214 -122 301 -144 93 -24 274 -24 370 -1 116 29 263 108 349 188 89 83 133 141 181 237 179 362 59 800 -280 1021 -40 26 -98 58 -129 70 l-56 23 0 2114 0 2114 -250 0 -250 0 0 -2114z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.61e1af0ba687839ed7f95dcf7d01a43f.svg";
export { ForwardRef as ReactComponent };